import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appMaximizModal]'
})
export class MaximizModalDirective {

  constructor(private elRef: ElementRef) { }

}

